import React, { useMemo } from 'react';
import SkinComponent from './skins';
import { useShareablesTemplateRoot } from '../../hooks/useShareablesTemplateRoot';
import sanitizeHtml from 'sanitize-html';

export default function MarketInsights(props) {
    const {
        rootClasses: classes,
        parsedData,
        currentFrame,
        onImagesLoaded,
    } = useShareablesTemplateRoot(props);
    const {
        skin = props.skin || null,
    } = parsedData || {};
    const templateContent = useMemo(()=> {
        return parsedData
            ? {
                ...parsedData,
                text: sanitizeHtml(parsedData.text || ''),
            }
            : null;
    }, [parsedData]);

    if(!templateContent) return null;

    return (
        <>
            <div className={classes.root} id="templateRoot">
                <div className={classes.viewport}>
                    <SkinComponent
                        skin={skin}
                        templateContent={templateContent}
                        currentFrame={currentFrame}
                        onImagesLoaded={onImagesLoaded}
                    />
                </div>
            </div>
        </>
    );
}
